// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

//引入饿了么ui
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// import

Vue.use(ElementUI)

//全局常用样式
import './assets/css/main.less'

//全局过滤器filter
import * as filters from './utils/filters';
// 注册为全局
Object.keys(filters).forEach(key => {
  	Vue.filter(key, filters[key]);
})

//拓展验证
import * as validator from "./utils/validator"
Vue.prototype.$validator = validator;

//公用的指令库
import directive from "./utils/directive";
import Scrollbar from 'smooth-scrollbar';
Vue.use(directive,{Scrollbar:Scrollbar});

//公共函数库
import library from "./utils/library";
Vue.use(library);

//ajax插件
import axios from 'axios';
//格式化ajax数据
import qs from 'qs';
//md5插件
import md5 from 'js-md5';
//配置文件
import * as config from './utils/config';
Vue.prototype.$config = config;

//ajax请求插件
import http from "./utils/http";
Vue.use(http, {axios: axios, md5: md5, qs: qs, config: config, elementUI: ElementUI});

Vue.config.productionTip = false

//导航钩子 登录信息判断
router.beforeEach((to, from, next) => {
    // ElementUI.Message({
    //     message:to.path.toString(),
    //     type: 'success'
    // })

    if (to.path == '/login') {
        window.sessionStorage.removeItem('userInfo');
        window.sessionStorage.removeItem('accessToken');
    }
    let userInfo = JSON.parse(window.sessionStorage.getItem('userInfo'));
    let accessToken = window.sessionStorage.getItem('accessToken');
    // ElementUI.Message({
    //     message:JSON.stringify(userInfo)+accessToken.toString(),
    //     type: 'warn'
    // })
    if(!userInfo && !accessToken && to.path != '/login' && to.path != '/forget-password'){
        next({ path: '/login' });
    }else{
        next();
    }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js